import { CashoutChannel as ICashoutChannel, Channel as IChannel } from "@/websocket/model/channel";
import { ChannelType } from "@/websocket/model/enums/channel-type";
import { normalizeLength } from "@/websocket/utils/messages";
import { isV2Protocol } from "@/websocket/composables/use-openbet-ws-client";

export class Channel implements IChannel {
    constructor(
        public type: ChannelType,
        public id: number,
    ) {}
    toString(): string {
        return this.type + (isV2Protocol() ? "================" : "") + normalizeLength(this.id, 10);
    }
    public static fromString(string: string) {
        const type = string.slice(0, 6) as unknown as ChannelType;
        const id = Number(string.slice(isV2Protocol() ? 22 : 6));
        return new Channel(type, id);
    }
}

export class CashoutChannel implements ICashoutChannel {
    public type = ChannelType.Cashout;
    constructor(public token: string) {}
    toString(): string {
        return this.type + this.token;
    }
    public static fromString(string: string) {
        const token = string.slice(8);
        return new CashoutChannel(token);
    }
}
